var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",class:_vm.inputClass,attrs:{"type":"text","inputmode":"decimal","placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm.display},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur}})}
var staticRenderFns = []

export { render, staticRenderFns }